<div class="container-fluid bg-color" style="top: 0px;position: fixed;width: 100%">
  <div class="row">
    <div class="col-lg-6 col-xl-5 mx-auto">
      <div class="text-center mt-5">
        <!-- <img src="assets/images/paylogo.svg" class="img-fluid"> -->
        <img src="assets/images/pay10logo.png" class="img-fluid">
      </div>
      <div class="card flex-row mt-2 border-0 shadow overflow-hidden">
        <div class="card-img-left d-none d-md-flex">
          
        </div>
        <div class="card-body p-sm-4">
          
          <h5 class="card-title d-flex flex-column align-items-center justify-content-center">Welcome ! Log in to your account.</h5>
          <!-- <div id="google_translate_element" class="d-flex align-items-center justify-content-center">
            <h5  style="margin-right: 10px; margin-top: -15px;">Select Language</h5>
          </div> -->
          <form #f="ngForm" *ngIf="!isLoggedIn" name="form" novalidate>
            <label class="form-label" for="username">Username</label>
            
            <div class="mb-2">
              <input type="text" class="form-control" id="username" pattern="[^\s]*" name="username" [(ngModel)]="form.username" 
              [ngClass]="{'is-invalid': f?.form?.controls?.username?.errors && f.submitted}" required >
              <div *ngIf="f?.form?.controls?.username?.errors && f.submitted" class="invalid-feedback" role="alert">
               Please Enter Username  {{this.idleTimer}}
               </div>
            </div>
            <label class="form-label" for="password">Password</label>
            <div class="form-floating mb-2">
              <app-show-hide-password>
                <input #password="ngModel" inputRef [(ngModel)]="form.password" pattern="[^\s]*" autocomplete="current-password"
                  class="form-control" [ngClass]="{'is-invalid': f?.form?.controls?.password?.errors && f.submitted}"
                  id="password" maxlength="16" name="password" required
                  type="password" value="12345678">
              </app-show-hide-password>
              <div *ngIf="f?.form?.controls?.password?.errors && f.submitted" class="invalid-feedback" role="alert"
                [style]="{ 'display': f?.form?.controls?.password?.errors && f.submitted ? 'block':'none' }"> Please
                Enter Password
              </div>
            </div>
            <div class="form-check mb-3">
              <input class="form-check-input" id="authCheck" (change)="toggle($event)" type="checkbox">
              <label class="form-check-label" for="authCheck"> Remember Me </label>
            </div>
            <ng-container *ngIf="visible">
              <div class="alert alert-danger" >
                  <p>
                    Invalid Username or Password!
                  </p>
              </div>
          </ng-container>
            <div class="d-grid mb-2">
              <button (click)="onLoggedin($event,f)" class="btn btn-primary me-2 mb-2 mb-md-0 btn-small" type="submit">LOGIN</button>
              </div>
              <div class="form-group">
                <div *ngIf="f.submitted && isLoginFailed" class="alert alert-danger" role="alert">
                  Log in failed: {{ errorMessage }}
                </div>
             </div>
            <a class="d-block text-center mt-2 small"routerLink="/auth/forgot-password"> Forgot Password ?</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

